/**
 * True when the given pathname is the prize payout area (`/{locale}/withdraw`
 * or `/{locale}/withdraw-request`). Used to keep the claim flow free of
 * global promos such as the PhotobookBanner.
 */
export default function isPayoutPath(pathname) {
  const parts = (pathname || '').split('/');
  const isPayout = (segment) => segment === 'withdraw' || segment === 'withdraw-request';
  // locale-prefixed (/us/withdraw) and the locale-less link from the winner email (/withdraw-request)
  return isPayout(parts[2]) || isPayout(parts[1]);
}
